import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ToxicGasCreate, ToxicGasDelete, ToxicGasRefresh, ToxicGasUpdate } from './toxic-gas.action';
import { ToxicGas } from '../../toxic-gas';
import { ToxicGasService } from '../../toxic-gas.service';
import { readStatusSnapshot, writeStatusSnapshot } from '../../../status-snapshot-cache';

const TOXIC_GAS_SNAPSHOT_KEY = 'home:toxic-gas:snapshot';

export class ToxicGasStateModel {
  data: ToxicGas[] = [];
  loading!: boolean;
}

@State<ToxicGasStateModel>({
  name: 'ToxicGas',
  defaults: {
    data: [],
    loading: false
  }
})
@Injectable()
export class ToxicGasState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ToxicGasService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ToxicGasStateModel) {
    return state.data;
  }

  @Action(ToxicGasRefresh)
  refresh({ getState, patchState }: StateContext<ToxicGasStateModel>) {
    patchState({ loading: true });

    if (!getState().data?.length) {
      const snapshot = readStatusSnapshot<ToxicGas[]>(TOXIC_GAS_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ data: snapshot });
    }

    this._service.getAll().toPromise().then(
      data => {
        patchState({ data, loading: false });
        writeStatusSnapshot(TOXIC_GAS_SNAPSHOT_KEY, data);
      },
      error => {
        patchState({ loading: false });
        console.error(error);
      }
    );
  }

  @Action(ToxicGasCreate)
  create({ getState, patchState }: StateContext<ToxicGasStateModel>, { item }: ToxicGasCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    const data = [...getState().data, item];
    patchState({ data });
    writeStatusSnapshot(TOXIC_GAS_SNAPSHOT_KEY, data);
  }

  /**
   * Replaces an updated Toxic Gas item in place so edits and approvals do not move its card to the bottom of the panel.
   * @param id The Toxic Gas identifier.
   * @param item The updated item from SignalR.
   */
  @Action(ToxicGasUpdate)
  update({ getState, patchState }: StateContext<ToxicGasStateModel>, { id, item }: ToxicGasUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      // Replace at the same position instead of removing and appending.
      const data = state.data.map((x, i) => i === index ? item : x);
      patchState({ data });
      writeStatusSnapshot(TOXIC_GAS_SNAPSHOT_KEY, data);
    }
  }

  @Action(ToxicGasDelete)
  delete({ getState, patchState }: StateContext<ToxicGasStateModel>, { id }: ToxicGasDelete) {
    const data = getState().data.filter(x => x.id !== id);
    patchState({ data });
    writeStatusSnapshot(TOXIC_GAS_SNAPSHOT_KEY, data);
  }

}
